import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/pages/site/LegalPage";

export const Route = createFileRoute("/privacy-policy")({
  component: () => <LegalPage slug="privacy-policy" />,
});
